//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { createContext } from 'react';

// LA - Loyatly Accounts
// ALA - Active Loyalty Account

const Context = createContext({
  isLoggedIn: false,
  loading: false,
  userInfo: {},
  customerAccounts: [],
  LA: [],
  ALA: {},
  ACA: {},
  billingAccount: {},
  sidebar: true,
  org: [],
  pathName: [],
  redirectionLinks: {},
  reportResCount: 0,
  language: [],
  selectedLanguage:'',
  pointsBalance: {}
});

export default Context;
